/* eslint-disable react/prop-types */
// @flow
import React from 'react';
import { useSelector } from 'react-redux';

import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import GuideButton from 'components/GuideButton';

/**
 * StdDialogTitle should be used instead of the MUI DialogTitle. The primary purpose of this component is to support an
 * optional back and close button. Due to the way MUI DialogTitle was written, this does not wrap that component.
 *
 * This component is meant to be used with StdDialog.
 */
const StdDialogTitle = (props) => {
  const theme = useTheme();

  const {
    children,
    colorBar = theme.palette.background.paper,
    guideId,
    id,
    onBack,
    onClose,
    sharedcomponentid,
    showBackButton,
    showCloseButton,
    sx: ferrySx = {},
    showDivider = true,
    variant = 'dialog',
    spacious = false,
    contentSx,
    ...other
  } = props;

  const handleBackKeyDown = (event) => {
    if (event.keyCode === 13) onBack();
  };

  const handleCloseButton = (event) => {
    onClose(event, 'CLOSE_BUTTON');
  };

  function renderBackButton() {
    if (showBackButton) {
      return (
        <IconButton
          size='small'
          variant='tonal'
          aria-label='Back'
          id='dlg-back'
          onClick={onBack}
//////////////////////////////////////////////////////
          onTouchEnd={onBack}
///////////////////
          onKeyDown={handleBackKeyDown}
        >
          <ArrowBackRounded />
        </IconButton>
      );
    }
    return null;
  }

  function renderCloseButton() {
    if (showCloseButton) {
      return (
        <IconButton
          size='small'
          variant='tonal'
          aria-label='Close'
          id='dlg-close'
          onClick={handleCloseButton}
//////////////////////////////////////////////////////
          onTouchEnd={handleCloseButton}
///////////////////
        >
          <CloseRounded />
        </IconButton>
      );
    }
    return null;
  }

  const dragDialog =
    useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'dragDialog')) && variant === 'dialog';

  return (
    <Stack>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        id={id || 'std-dialog-title'}
        sharedcomponentid={sharedcomponentid || 'STD_DIALOG'}
        sx={{
          backgroundColor: colorBar,
          px: 3,
          pt: spacious ? 3 : 2,
          pb: 2,
          ...contentSx,
        }}
        {...other}
      >
        <Stack
          id='draggable-dialog-title'
          direction='row'
          gap={2}
          alignItems='center'
          sx={{ ...(dragDialog && { cursor: 'move' }) }}
        >
          {dragDialog && <DragIndicatorIcon color='disabled' fontSize='medium' />}
          {renderBackButton()}
          <Typography
            align='left'
            component='h2'
            variant='titleMedium'
            sx={{ width: '100%', lineHeight: '40px', ...ferrySx }}
          >
            {children}
          </Typography>
        </Stack>
        <Stack direction='row'>
          <GuideButton guideId={guideId} />
          {renderCloseButton()}
        </Stack>
      </Stack>
      {showDivider && <Divider />}
    </Stack>
  );
};

export default StdDialogTitle;
